import { render, staticRenderFns } from "./LawMatterEvidenceForm.vue?vue&type=template&id=61571ec2&"
import script from "./LawMatterEvidenceForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterEvidenceForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterEvidenceForm.vue?vue&type=style&index=0&id=61571ec2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports